<template>
<div class="chapter">
<div class="inner_page">
<div id="cover">
<img alt="The Return of Mr Campion" class="cover-image" src="images/the_return_of_mr_campion_final.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?34f36e90